// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__1nffQ","pulse":"Skeleton_pulse__2Q9It"};